import { BooleanIconCell } from "@repo/design-system/components/grids";

export const BooleanIconRenderer = (col) => (rowData) => {
    const value = rowData?.[col?.field];

    const {
        width,
        activeClass, inactiveClass,
        activeIcon, inactiveIcon,
        activeTooltip, inactiveTooltip
    } = col?.config?.booleanIconRenderer;

    return (
        <BooleanIconCell value={value} width={width}
            // Class
            activeClass={activeClass}
            inactiveClass={inactiveClass}
            // Icon
            activeIcon={activeIcon}
            inactiveIcon={inactiveIcon}
            // Tooltip
            activeTooltip={activeTooltip}
            inactiveTooltip={inactiveTooltip}
        />
    );
};